import React, { FC } from "react";
import {
  faBitbucket,
  faGithub,
  faGitlab,
  faMicrosoft,
} from "@fortawesome/free-brands-svg-icons";
import {
  faBookBookmark,
  IconDefinition,
} from "@fortawesome/pro-solid-svg-icons";

import { ScmType } from "@protos/common/v1/common";

import { CodeLocationIcon } from "./CodeLocationIcon";

export interface RepoIconProps {
  repoName: string;
  repoProvider?: ScmType;
  repoHref?: string;
}

export const RepoIcon: FC<RepoIconProps> = ({
  repoName,
  repoProvider,
  repoHref,
}) => {
  let repoIcon: IconDefinition = faBookBookmark;
  if (
    repoProvider === ScmType.GITHUB ||
    repoProvider === ScmType.GITHUB_ENTERPRISE
  ) {
    repoIcon = faGithub;
  } else if (
    repoProvider === ScmType.GITLAB ||
    repoProvider === ScmType.GITLAB_SELFMANAGED
  ) {
    repoIcon = faGitlab;
  } else if (
    repoProvider === ScmType.BITBUCKET ||
    repoProvider === ScmType.BITBUCKET_DATACENTER
  ) {
    repoIcon = faBitbucket;
  } else if (repoProvider === ScmType.AZURE_DEVOPS) {
    repoIcon = faMicrosoft;
  }

  return <CodeLocationIcon label={repoName} href={repoHref} icon={repoIcon} />;
};
